var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.7577 32 32 24.7577 32 16C32 7.22632 24.7577 0 15.984 0C7.22632 0 0 7.22632 0 16C0 24.7577 7.24227 32 16 32ZM16 29.9262C8.27916 29.9262 2.07378 23.7049 2.07378 16C2.07378 8.27916 8.27916 2.05783 15.984 2.05783C23.7049 2.05783 29.9262 8.27916 29.9422 16C29.9422 23.7049 23.7208 29.9262 16 29.9262ZM11.5653 22.1416H13.1605C13.8943 22.1416 14.2293 21.7428 14.2293 21.1525V10.8475C14.2293 10.2732 13.8943 9.87438 13.1605 9.87438H11.5653C10.8475 9.87438 10.4965 10.2732 10.4965 10.8475V21.1525C10.4965 21.7428 10.8475 22.1416 11.5653 22.1416ZM18.8395 22.1416H20.4187C21.1366 22.1416 21.4875 21.7428 21.4875 21.1525V10.8475C21.4875 10.2732 21.1366 9.87438 20.4187 9.87438H18.8395C18.1057 9.87438 17.7707 10.2732 17.7707 10.8475V21.1525C17.7707 21.7428 18.1057 22.1416 18.8395 22.1416Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f71cbba5d06d54a1cc5f79953d71fa11.svg";
export { ForwardRef as ReactComponent };